import {useQuery, gql} from "@apollo/client";
import {useContext} from "react";
import {LocaleContext} from "../store/providers/LocaleProvider";
import {useLogger} from "./useLogger";

const QUERY = gql`
query getLegalPages($slug: String!, $locale: String!){
  legalPagesCollection(where:{slug: $slug}, limit: 1, locale: $locale){
     items{
      pageTitle
      slug
      placeMonthYear
      availableInTheNavigation
      text {
        json
      }
      download {
        url,
        size
      }
      company {
        companyName
      }
    }
  }
}`;

export const useLegalPageBySlug = (slug) => {
    const {localeUppercase} = useContext(LocaleContext)[0];
    const {logger} = useLogger();
    const {loading, error, data} = useQuery(QUERY, {variables: { slug: slug, locale: localeUppercase}, errorPolicy: "all", skip: !slug});
    const legalPage = data?.legalPagesCollection?.items?.[0];

    if (error?.message) {
        logger(error?.message, "error", "useLegalPageBySlug", error?.stack);
    }

    return {
        legalPage,
        loading,
        error
    };
};
